import { create } from "zustand";

export type SheetEntry =
  | { type: "poi"; poiId: string; context: "map" | "list" | "events" | "curated" }
  | { type: "events" }
  | { type: "curated" }
  | { type: "sponsors" }
  | { type: "faq" }
  | { type: "overlay" }
  | { type: "custom-path"; routeId: string };

interface SheetStackState {
  stack: SheetEntry[];
  /** Push entry onto stack. If at depth 2, replaces top. */
  push: (entry: SheetEntry) => void;
  /** Pop top entry. */
  pop: () => void;
  /** Replace top entry (or set as only entry if empty). */
  replace: (entry: SheetEntry) => void;
  /** Clear entire stack. */
  clear: () => void;
}

/** Derived selectors (not stored, computed inline) */
export const selectCurrent = (s: SheetStackState): SheetEntry | null =>
  s.stack.length > 0 ? s.stack[s.stack.length - 1] : null;

export const selectPrevious = (s: SheetStackState): SheetEntry | null =>
  s.stack.length > 1 ? s.stack[s.stack.length - 2] : null;

export const useSheetStack = create<SheetStackState>((set) => ({
  stack: [],

  push: (entry) =>
    set((state) => {
      if (state.stack.length >= 2) {
        // Replace top when at max depth
        return { stack: [...state.stack.slice(0, -1), entry] };
      }
      return { stack: [...state.stack, entry] };
    }),

  pop: () =>
    set((state) => ({
      stack: state.stack.slice(0, -1),
    })),

  replace: (entry) =>
    set((state) => {
      if (state.stack.length === 0) return { stack: [entry] };
      return { stack: [...state.stack.slice(0, -1), entry] };
    }),

  clear: () => set({ stack: [] }),
}));
